import React from 'react'
import BurgerMenu from '../../../node_modules/bootstrap-icons/icons/list.svg'
import './Burger.css';


function Burger({openSidebar}) {

  return (
    <div className="burger" onClick={openSidebar}>
            <img src={BurgerMenu} alt="" style={{width:'30px',height:'30px'}}/>
        </div>

  )
}

export default Burger